import { FunctionComponent } from 'react';
import { BatFigure } from '../BatFigure';

import classNames from 'classnames';
import classes from './FlyingBats.module.scss';

const FLYING_BAT_FLAPS = [
  { duration: 0.22, begin: 0 },
  { duration: 0.24, begin: -0.05 },
  { duration: 0.2, begin: -0.11 },
  { duration: 0.26, begin: -0.03 },
  { duration: 0.18, begin: -0.08 },
];

export const FlyingBats: FunctionComponent = () => {
  return (
    <div>
      {FLYING_BAT_FLAPS.map(({ duration, begin }, index) => (
        <div key={index} className={classes['flying-bats__bat']}>
          <div
            className={classNames(classes['flying-bats__wander'], {
              [classes['flying-bats__wander--alternate']]: index % 2 === 1,
            })}
          >
            <BatFigure flapDuration={duration} flapBegin={begin} />
          </div>
        </div>
      ))}
    </div>
  );
};
